/**
 * Mobile Navigation Logic - Full Screen Slide
 * Handles slide-in/slide-out page transitions for mobile menu.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Dynamic Header Height Calculation
  function updateHeaderHeight() {
    const header = document.querySelector('.site-header');
    if (header) {
      if (document.body.classList.contains('js-drawer-open-left')) {
        const height = header.offsetHeight || 60;
        document.documentElement.style.setProperty('--header-height', height + 'px');
      } else {
        const rect = header.getBoundingClientRect();
        const bottom = Math.max(0, rect.bottom); 
        document.documentElement.style.setProperty('--header-height', bottom + 'px');
      }
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('scroll', updateHeaderHeight);

  const observer = new MutationObserver(updateHeaderHeight);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  const navContainer = document.querySelector('#NavDrawer');
  if (!navContainer) return;

  // 0. Flatten DOM (Move all panels to root to avoid nested transform issues)
  const drawerInner = navContainer.querySelector('.drawer__inner');
  if (drawerInner) {
      const nestedPanels = navContainer.querySelectorAll('.mobile-nav-panel');
      nestedPanels.forEach(panel => {
          if (panel.getAttribute('data-depth') !== '0') {
               drawerInner.appendChild(panel);
          }
      });
  }

  // Initialize: Show root panel
  const rootPanel = navContainer.querySelector('.mobile-nav-panel[data-depth="0"]');
  if (rootPanel) {
    rootPanel.classList.add('active');
  }

  // Event Delegation
  navContainer.addEventListener('click', function(e) {
    // 1. Trigger Sub-menu
    const trigger = e.target.closest('.mobile-nav-trigger');
    if (trigger) {
      e.preventDefault();
      const targetId = trigger.getAttribute('data-target');
      const targetPanel = navContainer.querySelector(targetId);
      
      if (targetPanel) {
        // Open Navigation
        openPanel(targetPanel);
      }
      return;
    }

    // 2. Back Button (Entire Header Row)
    const backHeader = e.target.closest('.mobile-nav-header');
    if (backHeader) {
      e.preventDefault();
      closePanel(backHeader.closest('.mobile-nav-panel'));
      return;
    }
    
    // 3. Close Drawer (X button or outside click handled by theme.js generally, but ensuring clean state)
    if (e.target.closest('.js-drawer-close')) {
       resetMenu();
    }
  });

  // Helper: Open Panel
  function openPanel(panel) {
    // Hide current active panel (slide out left)
    const currentPanels = navContainer.querySelectorAll('.mobile-nav-panel.active');
    currentPanels.forEach(p => {
      p.classList.add('panel-out-left');
    });

    // Show new panel
    panel.classList.remove('hidden');
    // Force reflow
    void panel.offsetWidth; 
    panel.classList.add('active');
    
    // Scroll to top
    navContainer.querySelector('.drawer__inner').scrollTop = 0;
  }

  // Helper: Close Panel (Back)
  function closePanel(currentPanel) {
    // Hide current panel (slide out right)
    currentPanel.classList.remove('active');
    setTimeout(() => {
      currentPanel.classList.add('hidden');
    }, 300); // Match CSS transition

    // Restore previous panel
    // Logic: Find the panel with 'panel-out-left' that is highest depth < current
    // simplified: just remove 'panel-out-left' from the *parent* or *previous* active one.
    // Actually, we can just find the panel that this one was triggered from? 
    // Easier: Just remove 'panel-out-left' from ALL hidden parents? 
    // Or better: Just remove 'panel-out-left' from the *immediately preceding* panel.
    
    // We can assume a hierarchy. But easier strategy:
    // When opening, we mark the *previous* active as 'panel-out-left'. 
    // When closing, we specifically need to find which one to restore.
    
    // Let's rely on DOM structure if possible, or simple state.
    // Actually, standard pattern: 
    // Level 0 is active.
    // Level 1 opens -> Level 0 gets 'panel-out-left', Level 1 gets 'active'.
    // Level 2 opens -> Level 1 gets 'panel-out-left', Level 2 gets 'active'.
    
    // BACK:
    // Remove 'active' from Level 2.
    // Remove 'panel-out-left' from Level 1.
    
    // Implementation: Find the panel with highest depth that has 'active' and 'panel-out-left'.
    // Actually, we just need to find the parent panel.
    
    // Since our HTML structure might be flat or nested, let's assume flat for easier CSS.
    // If flat, we need a way to know parent.
    // We can store `data-parent` on the panels?
    
    // Let's try finding the last 'panel-out-left' element and restoring it.
    const suspendedPanels = Array.from(navContainer.querySelectorAll('.panel-out-left'));
    const parentPanel = suspendedPanels[suspendedPanels.length - 1];
    
    if (parentPanel) {
      parentPanel.classList.remove('panel-out-left');
    }
  }

  function resetMenu() {
    // Reset all
    navContainer.querySelectorAll('.mobile-nav-panel').forEach(p => {
       p.classList.remove('active', 'panel-out-left');
       if (p.getAttribute('data-depth') !== "0") {
         p.classList.add('hidden');
       } else {
         p.classList.add('active');
       }
    });
  }
});
